import { createApp } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import HeaderComponent from '../layouts/components/Header.vue';
import FooterComponent from '../layouts/components/Footer.vue';
import AgreementComponent from '../top/pages/Agreement.vue';
import "uikit/dist/js/uikit.min";
import 'uikit/dist/css/uikit.min.css';
import TopComponent from "../top/pages/Top.vue";
import FormComponent from "../form/components/Form.vue";

// vue-routerのルーティング定義
const routes = [
    { path: '/', component: TopComponent, name: 'top'},
    { path: '/form/:id?', component: FormComponent, name: 'form'},
    { path: '/agreement', component: AgreementComponent, name: 'consent'}
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})
const LEAVE_PAGE_ALARM_TEXT = '保存されていないデータは破棄されます。';

router.beforeEach((to, from, next) => {
    // formページから他のページに遷移する際に確認ダイアログを表示
    if (from.name === 'form' && to.name !== 'form') {
        const answer = window.confirm(LEAVE_PAGE_ALARM_TEXT);
        if (!answer) {
            next(from);
            return;
        }
    }
    next();
});

const setFillHeight = () => {
    // ナビゲーションバー等の高さを考慮する
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
};

window.addEventListener("resize", setFillHeight);
setFillHeight();

const SHIRONEKO_PROJECT = 'shironekoproject';
const MAGICIANWIZ = 'magicianwiz';

const app = createApp({
    mounted() {
        setFillHeight();
    },
    components: {
        'header-component' : HeaderComponent,
        'footer-component' : FooterComponent,
        'top-component' : TopComponent,
        'form-component' : FormComponent
    }
});
app.use(router);
app.mount('#app');
app.provide('SHIRONEKO_PROJECT', SHIRONEKO_PROJECT);
app.provide('MAGICIANWIZ', MAGICIANWIZ);
